module.exports = __webpack_public_path__ + "media/3x/Z-59f9f78a.png";